module.exports = __webpack_public_path__ + "img/3_0930.9388577.png";